module.exports = __webpack_public_path__ + "static/media/upload-cloud.e1e63945.svg";